import {
  WeatherDataTypeEnum,
  resolveWeatherDataType,
  weatherDataTypeDisplays,
  weatherIconDirectory
} from "../enums/weatherData-type.enum";
import { WeatherDataDisplayValue } from "../interfaces/weatherData-display-value.interface";
import { WeatherDataItem } from "../interfaces/weatherDataItem";

/** Max. number of different weather data values for schema */
export const MAX_WEATHER_DATA_DISPLAY_VALUES = 3;

/** Shown instead of a value for a configured data type without measurement. */
export const WEATHER_VALUE_MISSING = '--';

/**
 * Enriches the weather data for visualization.
 *
 */
export function getWeatherDataDisplayValues(
  weatherData: WeatherDataItem | undefined,
  maxCount: number = MAX_WEATHER_DATA_DISPLAY_VALUES): WeatherDataDisplayValue[] {

  const displayValues: WeatherDataDisplayValue[] = [];
  if (!weatherData?.dataValues || maxCount == 0) { return displayValues; }

  for (const dataValue of weatherData.dataValues) {
    if (displayValues.length === maxCount) { return displayValues; }

    // Data types this portal version does not know have neither label nor icon.
    const wType = resolveWeatherDataType(dataValue.valueType);
    if (!wType) continue;

    displayValues.push(getWeatherDataDisplayValue(wType, dataValue.value));
  }
  return displayValues;
}

/**
 * Enriches the detail data points of one weather station for visualization.
 */
export function getWeatherDataDetailDisplayValues(
  weatherData: WeatherDataItem | undefined): WeatherDataDisplayValue[] {

    return(getWeatherDataDisplayValues(weatherData, -1))
}

/** Latest measurement time of the detail data points, undefined without data. */
export function getWeatherDataTime(details: WeatherDataItem | undefined): string | undefined {
  if (!details?.dataValues?.length) { return undefined; }

  return details.dataDateTime;
}

function getWeatherDataDisplayValue(wType: WeatherDataTypeEnum, wValue: number | null | undefined): WeatherDataDisplayValue {
  const display = weatherDataTypeDisplays[wType];

  // A configured data type without measurement keeps its row: the placeholder
  // shows that the value is expected here but missing.
  if (wValue == null) {
    return {
      label: display.label,
      value: WEATHER_VALUE_MISSING,
      iconPath: weatherIconDirectory + display.icon,
      iconTransform: 'none'
    };
  }

  return {
    label: display.label,
    value: (wValue.toFixed(display.decimalPlaces) + ' ' + display.unit).trim(),
    iconPath: weatherIconDirectory + display.icon,
    iconTransform: display.isIconRotatedByValue ? 'rotate(' + wValue + 'deg)' : 'none'
  };
}
